import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// GET /api/shorts/access, once per signed-in user, shared by every caller of
// useShortsAccess (the dashboard and the content form in its modal).
export const fetchShortsAccessAsync = createAsyncThunk(
  "shorts/fetchAccess",
  async () => {
    try {
      const response = await axios.get("/api/shorts/access");
      return response.data;
    } catch (error) {
      return { enabled: false };
    }
  },
  // the live state, not a render's copy of it: callers that mount together fetch once
  { condition: (userId, { getState }) => getState().shorts.userId !== userId }
);

export const initialState = {
  // the user the access below belongs to (or is being fetched for)
  userId: null,
  // { enabled }, or null while loading
  access: null
};

export const shortsSlice = createSlice({
  name: "shorts",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchShortsAccessAsync.pending, (state, action) => {
        state.userId = action.meta.arg;
        state.access = null;
      })
      .addCase(fetchShortsAccessAsync.fulfilled, (state, action) => {
        if (state.userId === action.meta.arg) state.access = action.payload;
      });
  }
});

export default shortsSlice.reducer;
